import React from 'react';
import avatar from '../img/avatar.jpeg';
import { NavLink } from 'react-router-dom';

const navLinks = [
  { to: '/',           label: 'Home',       icon: '⌂',  exact: true  },
  { to: '/about',      label: 'About',      icon: '◎',  exact: true  },
  { to: '/experience', label: 'Experience', icon: '◈',  exact: true  },
  { to: '/portfolios', label: 'Projects',   icon: '⬡',  exact: true  },
  { to: '/education',  label: 'Education',  icon: '✦',  exact: true  },
  { to: '/contact',    label: 'Contact',    icon: '✉',  exact: true  },
];

function Navbar({ theme, toggleTheme }) {
  return (
    <div className="NavBar">
      <nav className="nav">
        <div className="profile">
          <div className="avatar-wrapper">
            <img src={avatar} alt="Rahat" />
            <span className="status-dot" title="Available for work" />
          </div>
          <p className="profile-name">Rahat</p>
          <p className="profile-role">Software Engineer</p>
        </div>

        <ul className="nav-items">
          {navLinks.map(({ to, label, icon, exact }) => (
            <li className="nav-item" key={to}>
              <NavLink to={to} exact={exact} activeClassName="active">
                <span className="nav-icon">{icon}</span>
                {label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="nav-footer">
          <button className="theme-toggle" onClick={toggleTheme} type="button">
            <span className="theme-icon">{theme === 'dark' ? '☀' : '☾'}</span>
            {theme === 'dark' ? 'Light Mode' : 'Dark Mode'}
          </button>
          <p className="footer-copy">© 2026 Rahat</p>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
